// PLUGINS IMPORTS //
import React, { ReactNode } from 'react'
import styled from 'styled-components/macro'

// COMPONENTS IMPORTS //

// EXTRA IMPORTS //

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  title: string
  style?: React.CSSProperties
  children: ReactNode
}

const SectionWrapper: React.FC<PropsType> = (props) => {
  return (
    <Wrapper style={props.style}>
      <TitleWrapper>
        <Title>{props.title.toUpperCase()}</Title>
        <Bar
          className='waypoint'
          data-animation='slide-in-left'
          data-delay='.18s'
        />
      </TitleWrapper>

      {props.children}
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  box-sizing: border-box;
  margin: 0 auto;
  max-width: 1250px;
  padding: 0 10px;
  // width: 100%;
  justify-content: center;
  display: flex;
  flex-direction: column;
  color: white;
  margin-bottom: ${'200px'};

  @media screen and (min-width: 600px) {
    padding: 0 20px;
  }
`

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const Title = styled.div`
  color: #fff;
  font-size: 25px;
  letter-spacing: 1.5px;
  font-family: 'Nunito';
`

const Bar = styled.div`
  background: #2a2e32;
  height: 4px;
  width: 70px;
  margin: 17px 0 100px 0;
`

export default SectionWrapper
